<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-preparation-counter(v-if='prepareForGame && counter' :counter="counter")
            template(v-else="")
                game-header(
                    v-if='!prepareForGame && !hideGameHeader',
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey"
                    :time='getTime'
                    :slug="type"
                    :game-type="parameters && parameters.courseType"
                    :is-homework="!!exerciseId"
                )
                chain(v-if='!gameFinished && !isNextExampleButtonShown', :items='items', @selectItem='processReply')
                .play-box__end-container(v-if='(gameFinished || isNextExampleButtonShown) && !isOlympiad')
                    fireworks(
                        v-if='gameFinished && !isOlympiad && !prepareForGame',
                        :is-mobile='isMobile'
                    )
                    .play-box__reaction-container
                        result-image.play-box__image(status='success')
                    result-buttons(
                        :exercise-id="exerciseId"
                        :games-type="parameters.courseType"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        template(slot="mainButton")
                            cs-button(
                                v-if="isNextExampleButtonShown"
                                @click="getExample"
                                v-focus=""
                                color="blue"
                                pattern="primary-outline"
                            )
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        slot
        cs-loader(v-else='')

</template>

<script>
    /*eslint-disable*/
    import Chain from "./Chain.vue";
    import FourthOneGameApi from "../../../../api/games/fourthOneGameApi.js";
    import { cloneDeep, shuffle } from "lodash";
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';

    const DEFAULT_VOLUME = 0.6;

    function DEFAULT_DATA () {
        return {
            chainOfAttempts: [[]],
            prepareForGame: true,
            isNextExampleButtonShown: false,
            amountOfExamples: 0,
            hideGameHeader: false,
            items: [],
            fourthOne: null,
        }
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin],
        data () {
            return DEFAULT_DATA();
        },
        methods: {
            fetchData () {
                this.getExercise()
                .then(() => {
                    this.getExample();
                    this.registerSounds();
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                })
            },
            beforeStart () {
                this.prepareForGame = false;
                if (!this.timer) {
                    this.setTimer();
                }
            },
            getExample () {
                this.isLoading = true;
                if (this.isAttemptCorrect && !this.isOlympiad) {
                    this.chainOfAttempts.push([]);
                    this.sendStat();
                }
                let paramsForRequest = {
                    mode: this.parameters.mode.substring(0, this.parameters.mode.length - 1),
                    firstTheme: this.parameters.themes[this.amountOfExamples].first,
                    secondTheme: this.parameters.themes[this.amountOfExamples].second,
                };
                FourthOneGameApi.getItems(paramsForRequest)
                .then(data => {
                    this.items = data.items;
                    this.fourthOne = data.fourthOne[0];
                    this.items.push(this.fourthOne);
                    this.items = shuffle(this.items);
                    this.isLoading = false;
                })
                .catch(err => this.showErrorMessage(err));
                if (!this.timer && !this.prepareForGame) {
                    this.setTimer();
                }
                this.isNextExampleButtonShown = false;
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts = this.isAttemptCorrect
                        ? this.chainOfAttempts[this.amountOfExamples - 1].length
                        : this.chainOfAttempts[this.amountOfExamples].length;
                this.gameStat.answers = this.amountOfExamples;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = cloneDeep(this.parameters);
            },
            calculatePercent () {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt(this.goodAnswers / (total) * 100);
                }
                return 0;
            },
            processReply (selectedItem, index) {
                this.stopAnswerTimer();
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 0
                };
                let clickedCell = document.querySelectorAll('.playground__item')[index];
                if (selectedItem.id === this.fourthOne.id) {
                    this.$createjs.Sound.play('clickCorrect');
                    clickedCell.classList.add('playground__item--correct');
                    elemOfExampleAttempts.good++;
                } else {
                    this.$createjs.Sound.play('clickIncorrect');
                    clickedCell.classList.add('shake');
                    setTimeout(() => {
                        clickedCell.classList.remove('shake')
                    }, 800);
                    elemOfExampleAttempts.bad++;
                }
                setTimeout(() => {
                    this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                    if (elemOfExampleAttempts.good) {
                        this.amountOfExamples++;
                        this.isAttemptCorrect = true;
                        this.hideGameHeader = true;
                        if (this.amountOfExamples === this.parameters.numOfExamples) {
                            this.gameDone();
                            return;
                        }
                        this.resetData();
                        if  (this.isOlympiad) {
                            this.chainOfAttempts.push([]);
                            this.isNextExampleButtonShown = false;
                            this.getExample();
                        }
                        return;
                    }
                    if (this.isOlympiad) {
                        this.resetData();
                        this.amountOfExamples++;
                        this.chainOfAttempts.push([]);
                        this.isNextExampleButtonShown = false;
                        this.isAttemptCorrect = false;
                        if (this.amountOfExamples === this.parameters.numOfExamples) {
                            this.gameDone();
                            return;
                        }
                        this.getExample();
                    }
                    this.isAttemptCorrect = false;
                }, 300);
            },
            resetData () {
                this.isNextExampleButtonShown = true;
                this.hideGameHeader = false;
                this.gameStarted = false;
                this.stopTimer();
                this.timer = null;
                this.items = [];
                this.fourthOne = null;
                if (this.answerTimer) {
                    clearInterval(this.answerTimer);
                    this.answerTimer = null;
                }
            },
            gameDone () {
                if (!this.isOlympiad) {
                    this.soundInstance = this.$createjs.Sound.play("gameDone");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.gameFinished = true;
                this.sendStat();
            },
            startGame () {
                this.gameStarted = true;
                this.showPlayButton = false;
                if (this.answerDuration) {
                    this.startAnswerTimer();
                }
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            }
        },
        computed: {
            goodAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.good);
                });
                return count;
            },
            badAnswers () {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => count += attempt.bad);
                });
                return count;
            },
        },
        components: {
            GamePreparationCounter,
            Chain,
        }
    }
</script>


<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box {
        align-items: flex-start;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .play-box--warning {
        display: table;
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 5;
        flex-direction: column;
    }

    .play-box__field {
        padding: 0 20px;
        text-align: center;
        font-size: 18px;
        user-select: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .play-box__word {
        padding: 10px;
        margin: 0 10px 10px 0;
        background: $x-color-white;
        border-radius: $border-radius-5;

        word-break: break-all;

        cursor: pointer;
    }

    .play-box__word:last-child {
        margin-right: 0;
    }

    .play-box__word--selected {
        color: $x-color-white;
        background: $hsl-color-green-58;
    }

    .play-box__word--unselected {
        color: $x-color-white;
        background: $hsl-color-red-62;
    }

    .play-box__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 20px;
        @include media($sm) {
            margin-bottom: 30px;
        }
        @include media($md) {
            font-size: 32px;
            line-height: 38px;
        }
    }

    .play-box__title {
        margin-bottom: 20px;
    }

    .play-box__subtitle {
        margin-bottom: 0;
    }

    .play-box__end-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
        width: 100%;
    }

    .play-box__reaction-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }

    .play-box__time {
        font-weight: 500;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        color: $hsl-color-green-58;
        margin-bottom: 30px;
    }

    .play-box__answers {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        @include media($md) {
            font-size: 22px;
            line-height: 26px;
        }
        @include media($lg) {
            font-size: 32px;
            line-height: 38px;
        }
        @include media($xl) {
            font-size: 42px;
            line-height: 50px;
        }
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($md) {
            align-self: auto;
        }
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }
</style>
